import { render } from "./AppCardCustom.vue?vue&type=template&id=5ae4cbb6&scoped=true"
import script from "./AppCardCustom.vue?vue&type=script&lang=js"
export * from "./AppCardCustom.vue?vue&type=script&lang=js"

import "./AppCardCustom.vue?vue&type=style&index=0&id=5ae4cbb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae4cbb6"]])

export default __exports__